import React from "react";
import { colors } from "../../constants/colors";
import { makeStyles } from "@material-ui/core/styles";
import { heatmapEmodeType, heatmapTmodeType } from "../../constants/constants";

const ColorScale = (props) => {
  const { value, heatmapType } = props;

  let position = 0;
  let min;
  let max;
  let domainRange = [];

  if (heatmapType.type === heatmapEmodeType) {
    min = heatmapType.swsLimit[0];
    max = heatmapType.swsLimit[1];
  } else if (heatmapType.type === heatmapTmodeType) {
    min = heatmapType.thicknessLimit[0];
    max = heatmapType.thicknessLimit[1];
  }

  let size = 6;
  let step = (max - min) / (size - 1);
  for (var i = 0; i < size; i++) {
    domainRange.push(min + step * i);
  }

  // Calculate the position of the triangle
  if (value) {
    let percentage = 100 * ((max - value) / (max - min));
    if (percentage > 100) {
      percentage = 100;
    } else if (percentage < 0) {
      percentage = 0;
    }

    position = percentage.toFixed(2) + "%";
  }

  const tickMarkPosition = (tickValue) => {
    let positionFromTop = 100 * ((max - tickValue) / (max - min));
    return `${positionFromTop}%`;
  };

  const useStyles = makeStyles({
    colorBar: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      background: `linear-gradient(180deg, ${colors.swsPlotColorStop0} 0%, ${colors.swsPlotColorStop1} 10%,  ${colors.swsPlotColorStop2}  20%, ${colors.swsPlotColorStop3}  30%, ${colors.swsPlotColorStop4}  40%, ${colors.swsPlotColorStop5}  50%, ${colors.swsPlotColorStop6}  60%, ${colors.swsPlotColorStop7}  70%, ${colors.swsPlotColorStop8}  80%, ${colors.swsPlotColorStop9}  90%, ${colors.swsPlotColorStop10}  100%)`,
      height: "100%",
      width: "10px",
    },
    triangle: {
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "10px 15px 10px 0",
      borderColor: `transparent white transparent transparent`,
      position: "absolute",
      right: "-15px",
      top: position,
      opacity: position === 0 ? 0 : 1,
      marginTop: "-10px",
      transition: "all 0.5s ease",
    },
    tick: {
      height: "1px",
      width: "100%",
      backgroundColor: "white",
      position: "absolute",
    },
    number: {
      position: "absolute",
      right: "13px",
      justify: "right",
      transform: "translateY(-50%)",
      fontSize: "0.9rem",
    },
  });

  const classes = useStyles(props);
  return (
    <div className={classes.colorBar}>
      <span style={{ position: "relative", top: "-25px", left: "-5px" }}>
        {heatmapType.type === heatmapEmodeType ? "m/s" : "mm"}
      </span>
      <div
        className={classes.tick}
        style={{ top: tickMarkPosition(domainRange[5]) }}
      >
        <div className={classes.number}>{domainRange[5].toFixed(1)}</div>
      </div>
      <div
        className={classes.tick}
        style={{ top: tickMarkPosition(domainRange[4]) }}
      >
        <div className={classes.number}>{domainRange[4].toFixed(1)}</div>
      </div>
      <div
        className={classes.tick}
        style={{ top: tickMarkPosition(domainRange[3]) }}
      >
        <div className={classes.number}>{domainRange[3].toFixed(1)}</div>
      </div>
      <div
        className={classes.tick}
        style={{ top: tickMarkPosition(domainRange[2]) }}
      >
        <div className={classes.number}>{domainRange[2].toFixed(1)}</div>
      </div>
      <div
        className={classes.tick}
        style={{ top: tickMarkPosition(domainRange[1]) }}
      >
        <div className={classes.number}>{domainRange[1].toFixed(1)}</div>
      </div>
      <div
        className={classes.tick}
        style={{ top: tickMarkPosition(domainRange[0]) }}
      >
        <div className={classes.number}>{domainRange[0].toFixed(1)}</div>
      </div>

      <div className={classes.triangle} />
    </div>
  );
};

export default ColorScale;
